import { render } from "./modalPopup.vue?vue&type=template&id=1bb844a1&scoped=true"
import script from "./modalPopup.vue?vue&type=script&lang=js"
export * from "./modalPopup.vue?vue&type=script&lang=js"

import "./modalPopup.vue?vue&type=style&index=0&id=1bb844a1&scoped=true&lang=css"
import "./modalPopup.vue?vue&type=style&index=1&id=1bb844a1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb844a1"]])

export default __exports__